import React from 'react'
import { css } from 'emotion'
import { CFImage, CFView, PrimaryModal } from 'components'
import { doorDash, skipTheDishes, uberEats } from 'images'

export default props => {
  return (
    <PrimaryModal
      title={'Choose Delivery Provider'}
      isOpen={props.showModal}
      onRequestClose={props.onRequestClose}
    >
      <CFView className={styles.container}>
        <CFView column alignCenter w="100%">
          <a
            href={`https://order.online/store/35851659?hideModal=true&redirected=true&delivery=true`}
          >
            <CFView hover>
              <CFImage maxWidth="290px" src={doorDash} alt="Door Dash" />
            </CFView>
          </a>
          <a
            href={`https://www.order.store/store/akihana-sushi-1205-davie-street/yoUGF_g5VpeMa1W2nU776w`}
          >
            <CFView hover mt="15px">
              <CFImage maxWidth="290px" src={uberEats} alt="UberEats" />
            </CFView>
          </a>
        </CFView>
      </CFView>
    </PrimaryModal>
  )
}

const styles = {
  container: css({
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '400px',
    '@media (max-width: 767px)': {
      padding: '30px',
      width: '330px',
    },
  }),
}
